export default __webpack_public_path__ + "static/media/logo_mobile_header.487a1433.png";